import client from "./client";
import type { Chapter } from "./templates";

export const userChaptersApi = {
  /** Главы шаблона + per-user overrides (имя, isHidden). */
  list: (templateId: number) =>
    client.get<Chapter[]>(`/user-chapters/${templateId}`),

  /** Upsert override для текущего юзера. Пустая nameOverride =
   *  очистить переопределение (PDF возьмёт шаблонное имя). */
  patch: (
    chapterId: number,
    patch: { nameOverride?: string; isHidden?: boolean },
  ) => client.patch(`/user-chapters/${chapterId}`, patch),
};
